
const DOMAIN_PERSON_IN_CHARGE = 8875;

export const endpoint = {
  lockedBy: (caseId) => `/case/${caseId}/lockedBy`,
  discardUnlockCase: (draftId) => `/case/draft/${draftId}`,
  choosePersonUnlockCase: ({ draftId }) => `/case/draft/${draftId}/lockedBy`,
  personListOptions: ({ draftId, query }) => `/case/draft/${draftId}/field/${DOMAIN_PERSON_IN_CHARGE}/options${query ? '/search' : ''}`
};

export const translations = {
  unlock_case: 9689,
  unlock_case_modal_title: 9680,
  unlock_case_modal_discard: 9690,
  unlock_case_modal_discard_text: 9681,
  unlock_case_modal_choose_person: 9682,
  unlock_case_modal_choose_person_text: 9683,
  unlock_case_save: 9691,
  unlock_case_cancel: 3273,
  unlock_case_discard_success: 9692,
  unlock_case_person_success: 9693,
  unlock_case_fail: 9685
};
